import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { InsuranceService } from 'src/app/_service/insurance.service';
import { SharedService } from 'src/app/_service/shared.service';
import { TpaService } from 'src/app/_service/tpa.service';

@Component({
  selector: 'app-addedit-tpa-insurance',
  templateUrl: './addedit-tpa-insurance.component.html',
  styleUrls: ['./addedit-tpa-insurance.component.css']
})
export class AddeditTpaInsuranceComponent implements OnInit {

  tpaInsuranceForm: FormGroup;submitted = false;loading:boolean=false;TpaInsId: any = '';
  tpaList = [];insuranceCompanyList = [];

  constructor(private formBuilder: FormBuilder, private activateRoute: ActivatedRoute, private tpaService: TpaService, private sharedapi:SharedService, private router:Router, private insuranceService : InsuranceService) {
    this.tpaInsuranceForm = this.formBuilder.group({
      'tpa_id':[null, Validators.required],
      'ins_comp_id': [null, Validators.required],
      'gipsa': [null, Validators.required],
      'status': [null, Validators.required]
    });

    this.activateRoute.params.subscribe(params => {
      if(params['tpa_ins_id']) {
        this.TpaInsId = params['tpa_ins_id'];
        this.patchTpaData();
      }
    })
  }

  ngOnInit(): void {
    this.getTpaList();
    this.getInsuranceCompanyList();
  }

  get f() { return this.tpaInsuranceForm.controls; }

  patchTpaData(){
    this.tpaService.getTpaInsurance(this.TpaInsId).subscribe((response:any) => {
      if(response.status) {
        this.tpaInsuranceForm.patchValue({
          'tpa_id': response.data.tpa_id,
          'ins_comp_id': response.data.ins_comp_id,
          'gipsa': response.data.gipsa,
          'status': response.data.status,
        });
      }
    });
  }

  async createTpaInsurance(){
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.tpaInsuranceForm.invalid) {
        this.loading = false;
        return;
    }

    if(this.TpaInsId) {
      this.tpaInsuranceForm.value.id = parseInt(this.TpaInsId);
      await this.tpaService.updateTpaInsurance(this.tpaInsuranceForm.value).subscribe((response:any) =>{
        this.submitted = false;
        this.loading = false;
        if(response.status) {
          this.sharedapi.presentToast('Tpa Insurance Update Successfully');
          this.router.navigateByUrl('/tpa-insurance');
        } else {
          this.sharedapi.presentToast(response.msg);
        }
      }, error => {
          this.sharedapi.checkError(error);
      });
    } else {
      await this.tpaService.addTpaInsurance(this.tpaInsuranceForm.value).subscribe((response:any) =>{
        this.submitted = false;
        this.loading = false;
        if(response.status) {
          this.sharedapi.presentToast('Tpa Insurance Added Successfully');
          this.router.navigateByUrl('/tpa-insurance');
        } else {
          this.sharedapi.presentToast(response.msg);
        }
      }, error => {
        this.sharedapi.checkError(error);
      });
    }
  }

  async getTpaList(){
    await this.tpaService.gelTpaList().subscribe((data: any)=> {
      if(data.status) {
        this.tpaList = data.data;
      } else {
        this.tpaList = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getInsuranceCompanyList(){
    await this.insuranceService.gelInsCompanyList().subscribe((data: any)=> {
      if(data.status) {
        this.insuranceCompanyList = data.data;
      } else {
        this.insuranceCompanyList = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

}
